<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewAnalytics.targets.title') }}</h3>
    <v-tabs
        class="rounded light-shadow"
        show-arrows
        v-model="tabIndex"
    >
      <v-tab
          v-for="tab in tabs"
          append
      >
        {{ $t(tab.title) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabIndex">
      <v-tab-item>
        <v-card elevation="0"  class="pa-2 mt-2">
        <v-row>
          <v-col cols="12" md="4">
            <h4 class="mb-2">{{ $t('viewAnalytics.targets.sum_targets') }}</h4>
            <v-progress-circular
                v-if="!fetched"
                size="64"
                indeterminate
                color="primary"
                class="mx-auto d-block"
            ></v-progress-circular>
            <div v-for="type in typesUsersCommon" v-show="fetched">
              <v-text-field
                  :prefix="type.parameter === 'revenue_per_day' ? currencySymbol : ''"
                  :disabled="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_')"
                  :loading="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_')"
                  class="mb-2"
                  v-model="type.value"
                  outlined
                  :label="$t(`viewAnalytics.targets.${type.parameter}`)"
                  append-icon="$save"
                  :title="$t('common.save')"
                  @click:append="saveTarget('users_common', type)"
                  hide-details
              ></v-text-field>
            </div>
          </v-col>
            <v-col cols="12" md="12">
            <h4>{{ $t('viewAnalytics.targets.workers_targets')}}</h4>
            <v-progress-circular
                v-if="!usersIsFetched"
                size="64"
                indeterminate
                color="primary"
                class="mx-auto d-block"
            ></v-progress-circular>
            <v-data-table
                v-if="fetched"
                :headers="[
                    {text: this.$t('common.employee'), value: 'name', sortable: false},
                    {text: '', sortable: false, align:'end'},
                    {text: '', sortable: false, align:'end'},
                    {text: '', sortable: false, align:'end'},
                ]"
                :items="userTargets"
                elevation="0"
                :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      10, 50, 100,
                      //-1
                    ],
                  }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item="props">
                <tr>
                  <td class="text-xs-left">
                    {{ props.item.user.name }}
                  </td>
                  <template v-for="userTarget in userTargets.filter((userTarget)=>userTarget.user.id===props.item.user.id)" v-show="fetched">
                    <td v-for="type in userTarget.targets">
                      <v-text-field
                          :prefix="type.parameter === 'revenue_per_day' ? currencySymbol : ''"
                          :disabled="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_'+userTarget.user.id)"
                          :loading="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_'+userTarget.user.id)"
                          class="my-2"
                          v-model="type.value"
                          outlined
                          :label="$t(`viewAnalytics.targets.${type.parameter}`)"
                          append-icon="$save"
                          :title="$t('common.save')"
                          @click:append="saveTarget('user', type, userTarget.user)"
                          hide-details
                      ></v-text-field>
                    </td>
                  </template>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card elevation="0"  class="pa-2 mt-2">
          <v-row>
            <v-col cols="12" md="4">
              <h4 class="mb-2">{{ $t('viewAnalytics.targets.sum_targets') }}</h4>
              <v-progress-circular
                  v-if="!fetched"
                  size="64"
                  indeterminate
                  color="primary"
                  class="mx-auto d-block"
              ></v-progress-circular>
              <div v-for="type in typesPostsCommon" v-show="fetched">
                <v-text-field
                    :prefix="type.parameter === 'revenue_per_day' ? currencySymbol : ''"
                    :disabled="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_')"
                    :loading="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_')"
                    class="mb-2"
                    v-model="type.value"
                    outlined
                    :label="$t(`viewAnalytics.targets.${type.parameter}`)"
                    append-icon="$save"
                    :title="$t('common.save')"
                    @click:append="saveTarget('posts_common', type)"
                    hide-details
                ></v-text-field>
              </div>
            </v-col>
              <v-col cols="12" md="12">
              <h4>{{ $t('viewAnalytics.targets.posts_targets')}}</h4>
              <v-progress-circular
                  v-if="!postsIsFetched"
                  size="64"
                  indeterminate
                  color="primary"
                  class="mx-auto d-block"
              ></v-progress-circular>

              <v-data-table
                  v-if="postsIsFetched"
                  :headers="[
                    {text: this.$t('common.name'), value: 'name', sortable: true},
                    {text: '', sortable: false, align:'end'},
                    {text: '', sortable: false, align:'end'},
                    {text: '', sortable: false, align:'end'},
                ]"
                  :items="postsTargets"
                  elevation="0"
                  :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      10, 50, 100,
                      //-1
                    ],
                  }"
              >
                <template v-slot:footer.page-text="props">
                  {{
                    $t("tables.x_of_y", [
                      `${props.pageStart}-${props.pageStop}`,
                      props.itemsLength,
                    ])
                  }}
                </template>
                <template v-slot:item="props">
                  <tr>
                    <td class="text-xs-left">
                      {{ props.item.post.name }}
                    </td>
                    <template v-for="postTarget in postsTargets.filter((postTarget)=>postTarget.post.id===props.item.post.id)" v-show="fetched">
                      <td v-for="type in postTarget.targets">
                        <v-text-field
                            :prefix="type.parameter === 'revenue_per_day' ? currencySymbol : ''"
                            :disabled="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_'+postTarget.post.id)"
                            :loading="inputsAreUpdating.includes(type.parameter+'_'+type.type+'_'+postTarget.post.id)"
                            class="my-2"
                            v-model="type.value"
                            outlined
                            :label="$t(`viewAnalytics.targets.${type.parameter}`)"
                            append-icon="$save"
                            :title="$t('common.save')"
                            @click:append="saveTarget('post', type, postTarget.post)"
                            hide-details
                        ></v-text-field>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-slot:no-data>
                  {{ $t("common.no_data_available") }}
                </template>
                <template v-slot:no-results>
                  {{ $t("common.no_data_available") }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DatePicker from "@/components/common/DatePicker";
import {GChart} from "vue-google-charts";
import {mapFields} from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "Targets",
  components: {DatePicker, GChart},
  mixins: [CommonMixin],
  data:() => ({
    inputsAreUpdating:[],
    tabIndex:0,
  }),
  created() {
    this.$store.dispatch('targets/get');
    this.$store.dispatch('users/get');
    this.$store.dispatch('posts/get');
  },
  watch: {

  },
  computed: {
    ...mapFields('targets', [
      'fetched',
      'types',
      'added'
    ]),
    ...mapFields('users', [
      'users'
    ]),
    ...mapFields('posts', [
      'posts'
    ]),
    ...mapFields('posts', {'postsIsFetched':'fetched'}),
    ...mapFields("users", { usersIsFetched: "fetched" }),
    tabs(){
      return [
        {
          title: this.$t('viewAnalytics.workers.title')
        },
        {
          title: this.$t('viewSettings.posts.title')
        }
      ]
    },
    userTargets(){
      let result = [];
      this.users.forEach((user)=>{
        let targets = JSON.parse(JSON.stringify(this.typesUsers));
        targets.forEach((item)=>{
          this.added.forEach((el)=>{
            if ( el.user_id === user.id && el.parameter === item.parameter ){
              item.value = el.value;
            }
          })
        })

        result.push({
          user: user,
          targets: targets
        })
      });
      return result;
    },
    postsTargets(){
      let result = [];
      this.posts.forEach((post)=>{
        let targets = JSON.parse(JSON.stringify(this.typesPosts));
        targets.forEach((item)=>{
          this.added.forEach((el)=>{
            if ( el.post_id === post.id && el.parameter === item.parameter ){
              item.value = el.value;
            }
          })
        })

        result.push({
          post: post,
          targets: targets
        })
      });

      return result;
    },
    typesUsers(){
      return this.types.filter( item=>item.type==='user');
    },
    typesPosts(){
      return this.types.filter( item=>item.type==='post');
    },
    typesPostsCommon(){
      let items = this.types.filter( item=>item.type==='posts_common');
      items.forEach((item)=>{
        this.added.forEach((el)=>{
          if ( el.type==='posts_common' && el.parameter === item.parameter ){
            item.value = el.value;
          }
        })
      })
      return items;

    },
    typesUsersCommon(){
      let items = this.types.filter( item=>item.type==='users_common');
      items.forEach((item)=>{
        this.added.forEach((el)=>{

          if ( el.type==='users_common' && el.parameter === item.parameter ){
            item.value = el.value;
          }
        })
      })
      return items;

    }
  },
  methods: {
    saveTarget(type, target, owner){
      if (!(String(target.value).replace(/,/g, '.')==parseFloat(String(target.value).replace(/,/g, '.')))){
        this.$error(this.$t('form.validationErrors.must_be_float'))
        return;
      }
      let post = null;
      let user = null;
      switch (type){
        case 'post':
          post = owner
          break;
        case 'user':
          user = owner
          break;
      }
      if (user) target.user_id = user.id;
      if (post) target.post_id = post.id;
      let loadParamName = `${target.parameter}_${target.type}_${( user ? user.id : "" )}${( post ? post.id : "" )}`;
      this.inputsAreUpdating.push(loadParamName);
      target.type = type;
      this.$store.dispatch('targets/update', target).finally(()=>{
        this.inputsAreUpdating.splice(this.inputsAreUpdating.findIndex((o)=>o===loadParamName), 1)
      })
    }
  }
}
</script>

<style scoped>

</style>